module.exports = __webpack_public_path__ + "static/img/pcbIlhada-1.fde1324.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/pcbIlhada-1.svg
// module id = DwkP
// module chunks = 0